var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c-info_svg__nc-icon-wrapper",
    fill: "#111",
    stroke: "#111"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    "data-stroke": "none",
    cx: 8.5,
    cy: 5,
    r: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 8.5,
    cy: 8.5,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.5 12.5v-4"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSIjMTExMTExIiBzdHJva2U9IiMxMTExMTEiPjxjaXJjbGUgZGF0YS1jb2xvcj0iY29sb3ItMiIgZGF0YS1zdHJva2U9Im5vbmUiIGN4PSI4LjUiIGN5PSI1IiByPSIxIiBzdHJva2U9Im5vbmUiLz4gPGNpcmNsZSBmaWxsPSJub25lIiBzdHJva2U9IiMxMTExMTEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBjeD0iOC41IiBjeT0iOC41IiByPSI3Ii8+IDxsaW5lIGRhdGEtY29sb3I9ImNvbG9yLTIiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiB4MT0iOC41IiB5MT0iMTIuNSIgeDI9IjguNSIgeTI9IjguNSIvPiA8L2c+PC9zdmc+";
export { SvgCInfo as ReactComponent };